<template>
  <div class="px-4">
    <TableItemForManualGrading v-for="item in manual_grading_data" :key="item.id" :item="item" :access_type="user_access_type" />
  </div>
</template>

<script>
import TableItemForManualGrading from './TableItemForManualGrading.vue';
export default {
  components: {
    TableItemForManualGrading
  },
  data() {
    return {
      items: [],
      user_access_type: "",
      manual_grading_data: [],
    };
  },
  methods: {
    fetchManualGradingExamData() {
      this.$store.dispatch('exam/getManualGrading')
        .then(res => {
          let data = res.data
          this.manual_grading_data = [
            ...data.data
          ]
          this.user_access_type = data.access_type
        })
    },
  },
  created() {
    if(this.role_modules.some(item => item.value == 'exam.create')){
      this.fetchManualGradingExamData()
    }
    else
      this.fetchApplicantExam()
  },
};
</script>
